import { gql } from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as React from 'react';

import { SimpleEventSponsor_OrganizationFragment } from './graphql-types/SimpleEventSponsor_OrganizationFragment';

export const SimpleEventSponsor: React.FC<{
  sponsor: SimpleEventSponsor_OrganizationFragment;
  isHtml: boolean;
}> & {
  sponsorFragment: DocumentNode;
} = (props) => {
  return (
    <>
      {props.isHtml ? (
        <b>{props.sponsor.displayName}</b>
      ) : (
        <>
          - {props.sponsor.displayName}
          <br />
        </>
      )}
    </>
  );
};

SimpleEventSponsor.sponsorFragment = gql`
  fragment SimpleEventSponsor_OrganizationFragment on Organization {
    _id
    displayName
  }
`;
